import requests from "./httpService";

const MembershipCategoryServices = {

    getMembershipCategory: async () => {
        return requests.get(`/membership-category`);
    },
    membershipCategoryStatusUpdate: async (id, body) => {
        return requests.patch(`/membership-category/${id}`, body);
    },
    updateMembershipsCategory: async (id, body) => {
        return requests.put(`/membership-category/${id}`, body);
    },
    createMembershipCategory: async (body) => {
        return requests.post(`/membership-category`, body);
    },
    deleteMembershipCategory: async (id) => {
        return requests.delete(`/membership-category/${id}`);
    }



}
export default MembershipCategoryServices;